export default __webpack_public_path__ + "static/media/53t.5f46e9ef.jpg";